export default __webpack_public_path__ + "static/media/vin kruttiventi.8a302985.jpg";